import { CheckCircle2, Clock, KeyRound, MapPin } from "lucide-react";

const STATUS = { Completed: "bg-emerald-100 text-emerald-800", "In Progress": "bg-amber-100 text-amber-800", Scheduled: "bg-slate-100 text-slate-700", "Walk Away": "bg-rose-100 text-rose-800" };
const Pill = ({ s }) => <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${STATUS[s]}`}>{s}</span>;
const ADDRS = [["12 Barking Road", "E13 8HQ", "Completed"], ["4 Ilford Lane", "IG1 2JZ", "In Progress"], ["88 High Street North", "E6 2HJ", "Scheduled"], ["31 Romford Road", "E7 9HZ", "Walk Away"]];

const ListMock = () => (
  <div className="space-y-2 p-4">
    <div className="flex items-center justify-between"><p className="text-sm font-bold text-slate-900">Run · Mon 20 Oct · 08:00</p><span className="text-xs text-slate-500">2 of 4 done</span></div>
    <div className="h-1.5 rounded-full bg-slate-100"><div className="h-1.5 w-1/2 rounded-full bg-blue-600" /></div>
    {ADDRS.map(([a, p, s]) => (
      <div key={a} className="flex items-center justify-between rounded-lg border border-slate-200 bg-white px-3 py-2">
        <div><p className="text-xs font-semibold text-slate-900">{a}</p><p className="font-data text-[10px] text-slate-500">{p}</p></div><Pill s={s} />
      </div>))}
  </div>
);

const PhoneMock = () => (
  <div className="flex justify-center p-6">
    <div className="w-56 rounded-[2rem] border-[6px] border-slate-900 bg-slate-50 p-3 shadow-xl">
      <p className="text-center text-[10px] font-bold text-slate-900">Warrants</p>
      <div className="mt-2 space-y-1.5">
        {ADDRS.slice(0, 3).map(([a, , s]) => <div key={a} className="rounded-md bg-white p-2 shadow-sm"><p className="text-[10px] font-semibold">{a}</p><div className="mt-1"><Pill s={s} /></div></div>)}
      </div>
      <div className="mt-2 rounded-md bg-blue-600 py-1.5 text-center text-[10px] font-semibold text-white">Update status</div>
    </div>
  </div>
);

const Field = ({ label, value }) => (
  <div><p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">{label}</p><p className="mt-0.5 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-xs text-slate-900">{value}</p></div>
);

const LockMock = () => (
  <div className="space-y-3 p-5">
    <p className="flex items-center gap-2 text-sm font-bold text-slate-900"><KeyRound className="h-4 w-4 text-blue-700" /> Lock change · 4 Ilford Lane</p>
    <Field label="Lock type *" value="Euro cylinder, anti-snap" />
    <Field label="Key safe code" value="4 7 1 9" />
    <p className="flex items-center gap-2 text-xs text-slate-700"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> Telephone number left for key return</p>
    <Field label="Key return number" value="07700 900123" />
  </div>
);

const PINS = [[22, 30, "#2563eb"], [38, 52, "#2563eb"], [55, 35, "#16a34a"], [68, 60, "#16a34a"], [45, 72, "#ea580c"], [78, 28, "#ea580c"]];
const MapMock = () => (
  <div className="relative h-72 overflow-hidden bg-slate-200">
    <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 40 Q30 35 50 50 T100 45" stroke="#f8fafc" strokeWidth="3" fill="none" /><path d="M30 0 Q35 40 25 100" stroke="#f8fafc" strokeWidth="2" fill="none" />
      <path d="M70 0 Q60 50 75 100" stroke="#f8fafc" strokeWidth="2" fill="none" /><path d="M0 80 Q50 70 100 85" stroke="#bfdbfe" strokeWidth="4" fill="none" />
    </svg>
    {PINS.map(([x, y, c], i) => (
      <span key={`${x}-${y}`} className={`absolute flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white text-[10px] font-bold text-white shadow ${i === 2 ? "animate-pulse" : ""}`} style={{ left: `${x}%`, top: `${y}%`, background: c }}>{i + 1}</span>))}
    <div className="absolute bottom-3 left-3 rounded-lg bg-white/90 px-3 py-2 text-[10px] shadow backdrop-blur">
      {[["#2563eb", "Dan"], ["#16a34a", "Priya"], ["#ea580c", "Tom"]].map(([c, n]) => <p key={n} className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full" style={{ background: c }} />{n}</p>)}
    </div>
    <MapPin className="absolute right-3 top-3 h-5 w-5 text-slate-500" />
  </div>
);

const SheetMock = () => (
  <div className="overflow-hidden p-4 font-data text-[10px]">
    {[0, 1].map((g) => (
      <div key={g} className="mb-3">
        <div className="bg-blue-100 px-2 py-1 font-bold text-slate-900">{g ? "21/10/2026 · Start 09:00 · Locksmith: Priya" : "20/10/2026 · Start 08:00 · Locksmith: Dan"}</div>
        <div className="grid grid-cols-4 bg-blue-700 px-2 py-1 font-bold text-white"><span>#</span><span>Address</span><span>Status</span><span>Lock</span></div>
        {ADDRS.slice(0, 2 + g).map(([a, , s], i) => <div key={a} className="grid grid-cols-4 border-b border-slate-200 px-2 py-1"><span>{i + 1}</span><span className="truncate">{a}</span><span>{s}</span><span>{i === 1 ? "Euro" : ""}</span></div>)}
      </div>))}
  </div>
);

const CompaniesMock = () => (
  <div className="space-y-2 p-5">
    <p className="text-xs font-semibold text-slate-500">Working for</p>
    {[["Newham Lock Co", true], ["Eastside Security", false], ["Riverside Locks", false]].map(([n, on]) => (
      <div key={n} className={`flex items-center justify-between rounded-lg border px-3 py-2.5 text-sm ${on ? "border-blue-600 bg-blue-50 font-semibold text-blue-900" : "border-slate-200 bg-white text-slate-700"}`}>{n}{on && <CheckCircle2 className="h-4 w-4 text-blue-700" />}</div>))}
    <div className="rounded-lg border border-dashed border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900">New invite from Riverside Locks · Accept · Decline</div>
  </div>
);

const TeamMock = () => (
  <div className="space-y-2 p-5">
    {[ ["Dan Mitchell", "Locksmith", "E6, E13"], ["Priya Shah", "Warrant Officer", "External"], ["Tom Hale", "Engineer", "E7"], ["Asha Cole", "Dog Handler", "IG1"] ].map(([n, r, p]) => (
      <div key={n} className="flex items-center justify-between rounded-lg border border-slate-200 bg-white px-3 py-2">
        <div><p className="text-xs font-semibold text-slate-900">{n}</p><p className="font-data text-[10px] text-slate-500">{p}</p></div>
        <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-700">{r}</span>
      </div>))}
    <p className="flex items-center gap-1.5 pt-1 text-[10px] text-slate-500"><Clock className="h-3 w-3" /> Priya changed status to Completed · 10:42</p>
  </div>
);

const VisitsMock = () => (
  <div className="space-y-3 p-5">
    <div className="flex items-center justify-between border-b border-slate-200 pb-2">
      <div><p className="text-sm font-bold text-slate-900">Pre Warrant Visits</p><p className="text-[10px] text-slate-500">Assigned Warrant Officer</p></div>
      <Pill s="In Progress" />
    </div>
    <div className="space-y-2">
      {[["Morgan Ellis", "18 Barking Road · E6 1AA", "Scheduled"], ["Samira Khan", "4 Ilford Lane · IG1 2JZ", "Completed"]].map(([name, address, status]) => (
        <div key={name} className="rounded-lg border border-slate-200 bg-white p-3">
          <div className="flex items-center justify-between gap-2"><p className="text-xs font-semibold text-slate-900">{name}</p><Pill s={status} /></div>
          <p className="mt-1 text-[10px] text-slate-500">{address}</p>
          <p className="mt-2 text-[10px] text-slate-700">Visit Type · Vulnerability notes · Photos</p>
        </div>
      ))}
    </div>
  </div>
);

const MOCKS = { list: ListMock, phone: PhoneMock, lock: LockMock, map: MapMock, sheet: SheetMock, companies: CompaniesMock, team: TeamMock, visits: VisitsMock };

export const FeatureMock = ({ kind }) => {
  const Mock = MOCKS[kind];
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 shadow-2xl shadow-slate-900/10" data-testid={`feature-mock-${kind}`} aria-label="Example screen" role="img">
      <div className="flex items-center gap-1.5 border-b border-slate-200 bg-white px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-rose-400" /><span className="h-2.5 w-2.5 rounded-full bg-amber-400" /><span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
        <span className="ml-3 text-[11px] text-slate-400">Warrant Whizz</span>
      </div>
      <Mock />
    </div>
  );
};
